<script>
  import Tile from './Tile.svelte';

  let disabled = false;

  let tileStyles = ["black", "black", "black", "black", "black"];

  export let value;
  export let color;

  function repair(inputBox) {
    let text = inputBox.value;
    text = text.replace(/[^a-zA-Z]/, '');
    text = text.toUpperCase();
    text = text.slice(0,5);
    inputBox.value = text;
  }

  function modifySelection(inputBox) {
    inputBox.selectionStart = 0;
    inputBox.selectionEnd = value ? value.length : 0;
  }

  function changeColor(i) {
    if (tileStyles[i] == 'black')
      tileStyles[i] = 'yellow';
    else if (tileStyles[i] == 'yellow')
      tileStyles[i] = 'green';
    else
      tileStyles[i] = 'black';
  }

  $: color = tileStyles.map(s => {
    if (s == "black") return "-";
    else if (s == "yellow") return "y";
    else return "g";
  }).join("");

</script>

<div class="word">

  <div class="word layer">
    {#each Array(5) as _, i}
      <button
        class="tile {tileStyles[i]}"
        style="grid-row: 1; grid-column: {i+1}"
        on:click={() => changeColor(i)}
      >
        {#if value && value[i]}
          {value[i]}
        {/if}
      </button>
    {/each}
    <input
      class="word button"
      type="text"
      on:input={x => repair(x.target)}
      on:focus={x => modifySelection(x.target)}
      maxlength=5
      size=4
      {disabled}
      bind:value
    />

    <button style="margin-left: 10px; grid-row: 1; grid-column: 6" on:click={() => disabled = !disabled}>
      {#if disabled}
        <strong>T</strong>
      {:else}
        <strong>&#x1F58C;</strong>
      {/if}
    </button>
  </div>
  
</div>

<style>
  @media screen and (min-width:  350px) {
    .word {
      --tile-size: 1.5em;
      --font-size: 2em;
    }
  }

  @media not screen and (min-width:  350px) {
    .word {
      --tile-size: 1.3em;
      --font-size: 1.75em;
    }
  }
  .word {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .word strong {
    font-family: 'Roboto Slab', serif;
  }

  .word.layer {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    grid-template-rows: auto;
    gap: 5px;
    width: auto;
  }

  .word.layer input {
    grid-row: 1;
    grid-column: 1 / -2;
    padding: 0 0 0 0.75em;
    margin: 0;
    height: 2em;
    opacity: 50%;
    font-size: var(--tile-size);
    letter-spacing: var(--tile-size);
    color: #00000000;
    background-color: #00000000;
    border: 0;
  }

  .word.layer input:disabled {
    pointer-events: none;
  }

  .word.layer input::selection {
    opacity: 0;
  }

  .word button {
    background-color: var(--black);
    padding: 0;
    margin: 0;
    height: var(--tile-size);
    width: var(--tile-size);
    color: white;
    font-size: var(--font-size);
    border: 2px solid var(--gray);
  }

  .tile {
    width: var(--tile-size);
    height: var(--tile-size);
    text-align: center;
    font-weight: bold;
    font-size: var(--font-size);
    border: 0;
    margin: 0;
    padding: 0;
  }

  .tile.black {
    border: 0;
    background-color: var(--gray);
    color: white;
  }

  .tile.yellow {
    border: 0;
    background-color: var(--yellow);
    color: white;
  }

  .tile.green {
    border: 0;
    background-color: var(--green);
    color: white;
  }

  .tile.black.highlighted {
    border: 1px solid white;
  }

  .tile.black:active {
    background-color: var(--gray);
    filter: brightness(110%);
  }

  .tile.yellow:active {
    background-color: var(--yellow);
    filter: brightness(110%);
  }

  .tile.green:active {
    background-color: var(--green);
    filter: brightness(110%);
  }
</style>
